import { ref } from "vue"
import { User } from "./User"

/**
 * configure this manually via console to enable/disable debug mode in a few scenarios where
 * the user is not directly inleague=1 but is "effectively" inleague=1.
 * Those scenarios include
 *  - user is being impersonated, but the "underlying" user is inleague=1
 *  - the app is a dev build
 *
 * This can help sanity check that seeing debug stuff when impersonating a user is really "only visible to effectively inleague=1 users"
 */
const constrainedNonInLeagueDebugging = ref(false)
;(window as any).constrainedNonInLeagueDebugging = {
  get value() { return constrainedNonInLeagueDebugging.value },
  set value(v) { constrainedNonInLeagueDebugging.value = v }
}

const isDevBuild : boolean = process.env.NODE_ENV === "development" || !!process.env.LOCAL_STAGING

export const DEBUG = () : boolean => {
  const isInleague : boolean = User.isInleague

  const isInleagueButImpersonating : boolean = User.isImpersonating && (
    User.userData?.impersonatingUserEmail.toLowerCase() === "sam@inleague.io"
    || User.userData?.impersonatingUserEmail.toLowerCase() === "david@inleague.io"
  )

  return isInleague
    || (constrainedNonInLeagueDebugging.value && isInleagueButImpersonating)
    || (constrainedNonInLeagueDebugging.value && isDevBuild)
}
